"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NumberGeneralHandler", {
    enumerable: true,
    get: function() {
        return NumberGeneralHandler;
    }
});
const _catchError = require("src/helpers/catchError");
const _decimalgeneralhandler = require("../decimal/decimal.general.handler");
let NumberGeneralHandler = class NumberGeneralHandler extends _decimalgeneralhandler.DecimalGeneralHandler {
    async parseUserInput(params) {
        var _this;
        const value = (_this = await super.parseUserInput(params)) == null ? void 0 : _this.value;
        if (typeof value === 'number' && Math.floor(value) !== Math.ceil(value)) {
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt
            });
        }
        return {
            value
        };
    }
};
